module.exports = __webpack_public_path__ + "assets/static/png/tickets-red.790952745c75c0f4cb911ab1171624b2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/tickets-red.png
 ** module id = 522
 ** module chunks = 1
 **/